import { observable } from "mobx";
import Constants from "../../common/constants/Constants";
import HttpStatusCode from "../../common/constants/HttpErrorCode";
import { getRequest } from "../../common/helpers/RequestHelper";
import { IMarketIndex, IMarketIndexSummary, REGISTER_SOCKET_TYPE, STOCK_BG_COLOR_CONIG } from "../../common/model/Model";
import { appStore } from "../../common/store/AppStore";
import _ from 'lodash'
import { realtimeEvent } from "../../common/eventsource/RealtimeEvent";
class MarketOverviewStore {
    state = {
        symbols: ["VN-INDEX", "HNX-INDEX", "VN30", "UPCOM-INDEX"],
    }
    arrIndexStatic = ["^VNINDEX", "^HNXINDEX", "^VN30INDEX", "^UPCOMINDEX"];
    arrIndex = [
        {
            title: "VN-INDEX",
            indexCode: "^VNINDEX"
        },
        {
            title: "HNX-INDEX",
            indexCode: "^HNXINDEX"
        },
        {
            title: "VN30-INDEX",
            indexCode: "^VN30INDEX"
        },
        {
            title: "UPCOM-INDEX",
            indexCode: "^UPCOMINDEX"
        }
    ]
    arrHoursTicks = [9, 10, 11, 12, 13, 14, 15];
    @observable marketIndexsInfo?: IMarketIndexSummary[]
    async getMarketOverviewInfo() {
        const result = await getRequest(Constants.API_DASHBOARD_URL + 'GetMarketindexGrapForChart?listMarketSymbol=%5EVNINDEX,%5EHNXINDEX,%5EVN30INDEX,%5EUPCOMINDEX', true)
        if (result.status < HttpStatusCode.CODE_300) {
            let data = _.cloneDeep(this.marketIndexsInfo)
            this.marketIndexsInfo = result.body
            if (data) {
                this.marketIndexsInfo?.map((item, i) => {
                    item.data = data[i].data
                })
            }
            this.regisMarketInfo()
        }
    }
    regisMarketInfo() {
        let x = setTimeout(() => {
            if (appStore.isSocketConnected) {
                let symbols = "";
                this.arrIndexStatic.map((item) => {
                    symbols += item + ','
                })
                symbols = symbols.substring(0, symbols.length - 1);
                realtimeEvent.registerSocket(REGISTER_SOCKET_TYPE.RegisMarketInfo, symbols)
            }
        }, 2000)
    }
    async updateMarketOverViewInfo(data: IMarketIndex[]) {
        if (this.marketIndexsInfo) {
            this.marketIndexsInfo.map((item, i) => {
                let newInfo = data.find((index) => (index.stockSymbol === item.indexCode))
                if (newInfo && this.marketIndexsInfo) {
                    let t = _.cloneDeep(newInfo)
                    // @ts-ignore
                    if (this.marketIndexsInfo && this.marketIndexsInfo[i].data?.chgIndex && t.chgIndex && this.marketIndexsInfo[i].data?.chgIndex < t.chgIndex) {
                        this.marketIndexsInfo[i].colorUpdate = STOCK_BG_COLOR_CONIG.UP
                    }
                    // @ts-ignore
                    if (this.marketIndexsInfo && this.marketIndexsInfo[i].data?.chgIndex && t.chgIndex && this.marketIndexsInfo[i].data?.chgIndex > t.chgIndex) {
                        this.marketIndexsInfo[i].colorUpdate = STOCK_BG_COLOR_CONIG.DOWN
                    }
                    this.marketIndexsInfo[i].data = t
                    this.marketIndexsInfo[i].update = true;
                    setTimeout(() => {
                        if (this.marketIndexsInfo)
                            this.marketIndexsInfo[i].update = false
                        // @ts-ignore
                        this.marketIndexsInfo[i].colorUpdate = ""
                    }, 200)
                }
            })
        }
    }
}
export const marketOverviewStore = new MarketOverviewStore()
